import { Component, effect, Injector } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
// import { ApiService } from '../../services/api.service';
import { MainService } from '../../services/main.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LogoutModalComponent } from 'src/app/shared/logout-modal/logout-modal.component';
import { localStorageService } from 'src/app/services/localstorage.service';
import { SharedService } from 'src/app/services/shared.service';
import { CollectingModalComponent } from 'src/app/shared/collecting-modal/collecting-modal.component';
import { EnableDebtCollectionComponent } from 'src/app/shared/enable-debt-collection/enable-debt-collection.component';


@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrl: './sidemenu.component.scss',
})
export class SidemenuComponent {
  menuList: any = [];
  currentUrl: string = '';  // Store the current route
  activeMenuStates: { [path: string]: boolean } = {};  // Store active states for menu items
  bsModalRef: BsModalRef | undefined;
  userProfile: any;
  activeMenuIndex: any;
  isFloatingMenuOpen: boolean = false;
  doctor_debt_type: any;
  openmenu: boolean = false;
  logoRedirectPath: string[] = ['/app/dashboard'];
  disputes_data: any;

  constructor(private _router: Router, private _main: MainService, private modalService: BsModalService, private _local:localStorageService, public _shared: SharedService,private injector: Injector) {}

  ngOnInit() {
    effect(() => {
      const allLoginDataResponse: any = this._main._shared.authenticateApiResponse();
      const roleId = allLoginDataResponse?.doctor_profile?.role_id || allLoginDataResponse?.role_id;
      if (roleId === 5) {
        this.logoRedirectPath = ['/app/customer/list'];
      } else if (roleId === 4) {
        this.logoRedirectPath = ['/app/dashboard'];
      } else {
        this.logoRedirectPath = ['/app/dashboard'];
      }

      if (allLoginDataResponse.menu && allLoginDataResponse.menu.length) {
        this.menuList = [];
        this.disputes_data = allLoginDataResponse.disputes_data
        // fetch all parent menus with only path 0 . // 0 here means to display menu and 1 means do not display but is a route
        const parentMenus = allLoginDataResponse.menu.filter((menu: any) => !menu.parent_id && menu.only_path == 0);
        parentMenus.map((item: any) => {
          if (!item.show_to_business) {
            return;
          }
          if (item.submenu && item.submenu.length) {
            const submenus = item.submenu.filter((sub_menu: any) => sub_menu.only_path == 0);
            const menuItem = {...item};
            menuItem.submenu = submenus;
            this.menuList.push(menuItem);
          } else {
            this.menuList.push(item);
          }
        })
        
        this.currentUrl = this._router.url;
        this.updateMenuActiveStates();
        console.log(this.menuList);
        this._main._shared.sideMenus.set(this.menuList);
      }
      this.userProfile = this._local.customGetItem('userProfileData');
      this._shared.dispute_count = this.userProfile.doc_count;
    }, { injector: this.injector, allowSignalWrites: true });

    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.currentUrl = this._router.url;
      this.updateMenuActiveStates();
    });
  }

  private updateMenuActiveStates(): void {
    // Reset all menu states
    this.activeMenuStates = {};

    // Compute active state for each menu
    this.menuList.forEach((menu: any) => {
      // Check if the current URL starts with the menu path
      this.activeMenuStates[menu.path] = this.currentUrl.startsWith(menu.path);

      // If there are submenus, compute their active state
      if (menu.submenu) {
        menu.submenu.forEach((sub_menu: any) => {
          this.activeMenuStates[sub_menu.path] = this.currentUrl.startsWith(sub_menu.path);
        });
      }
    });
  }

  toggleMenu(selectedMenu: any): void {
    const { menu_id, submenu, path } = selectedMenu;
    this.doctor_debt_type = this._main.doctor_profile?.doctor_debt_type ?? '';
  
    if (menu_id === 30) {
      // if(!this.openmenu){
      //     this.isFloatingMenuOpen = true;
      //     this.openmenu = true;
      //   }else{
      //   this.openmenu = false
      //   this.isFloatingMenuOpen = false;
      // }
      this._router.navigate(['app/debt-recuvery']);
    }
  
    if(menu_id !== 30){
      if (submenu?.length) {
      selectedMenu.isOpen = !selectedMenu.isOpen;
    } else if (path) {
      this._router.navigate([path]);
    }
    }
    // if (menu === selectedMenu) {
    // } else {
    //   // menu.isOpen = false;
    // }
    // this.menuList.forEach((menu: any) => {
    // });
  }


  closeNavMenu() {
    const sidenav = document.getElementById('mySidenav');
    if (sidenav) {
      sidenav.style.transform = 'translate(-100%)';
    }
  }
  logoutModal() {
    const initialState = {
    };
    this.bsModalRef = this.modalService.show(LogoutModalComponent, {
      initialState,
      class: 'modal-dialog-centered'
    });
  }
  selectDebt(type: 'consumer' | 'commercial') {
    this.bsModalRef?.hide();  
    if(type == 'consumer' && this.doctor_debt_type != 2){
      this._router.navigate(['/app/debt-recuvery'], { queryParamsHandling: 'merge' });
    }
    else if(type == 'commercial' && this.doctor_debt_type != 1){
      this._router.navigate(['/app/debt-recuvery-comercial'], { queryParamsHandling: 'merge' });
    } else{
      event?.stopPropagation();
    }
  }
    showAddDebtCollectionModal(event: MouseEvent ,type : any){
      event.stopPropagation();
        this.bsModalRef = this.modalService.show(EnableDebtCollectionComponent, {
          initialState: {
            extra_data: {
              type: type,
            }
          }, 
          backdrop:true,
          class: 'modal-dialog-centered'
        });
        this.bsModalRef.onHidden?.subscribe((resp) => {
          if (resp) {
            this.openmenu = false;
          }
        })
    }

}
